export class IndentHarvestingDateReq {
    harvestingDate?: string;
    constructor(harvestingDate?: string) {
        this.harvestingDate = harvestingDate
    }
}